module.exports = __webpack_public_path__ + "img/logo.bdfc895d.png";